(function ($) {

    window.onhashchange = scrollToHash;
    $(function () {
        setTimeout(scrollToHash, 1000);
    })

    function scrollToHash() {
        const anchor = $(location).attr('hash').replace('#', '');
        const anchorEl = document.getElementById(anchor);
        if (anchorEl) {
            $('body').removeClass('scrolled');
            const top = Math.max(anchorEl.offsetTop, 0);
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top
            });
        }
    }
})(jQuery);
